import PropTypes from "prop-types";

export const contentItemProps = {
    currentPost: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.shape({
            rendered: PropTypes.string.isRequired,
        }),
        content: PropTypes.shape({
            rendered: PropTypes.string.isRequired,
        }),
    }),
}